import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["value", "size", "dropdownClassName", "width", "style", "className"],
  _excluded2 = ["className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Select } from 'antd';
import classNames from 'classnames';
import DixuEmpty from "../DixuEmpty/DixuEmpty";
import React from 'react';
import { toRem } from "../../utils/Utils";
const DixuSelect = _ref => {
  let {
      value,
      size,
      dropdownClassName,
      width,
      style,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-select', {
    'dixu-select--has-value': Array.isArray(value) ? value.length : value != null
  }, className);
  return /*#__PURE__*/React.createElement(Select, _objectSpread({
    className: classes,
    dropdownClassName: classNames('dixu-select-dropdown', dropdownClassName, {
      [`dixu-select-dropdown--size-${size}`]: size
    }),
    notFoundContent: /*#__PURE__*/React.createElement(DixuEmpty, null),
    style: _objectSpread({
      width: toRem(width)
    }, style),
    value,
    size
  }, rest));
};
DixuSelect.defaultProps = {
  width: undefined
};
const DixuOption = _ref2 => {
  let {
      className
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const classes = classNames('dixu-option', className);
  return /*#__PURE__*/React.createElement(Select, _extends({
    className: classes
  }, rest));
};
DixuSelect.Option = DixuOption;
export const basicFilterOption = (input, option) => {
  const {
    label,
    value
  } = option;
  return [label, value].some(e => {
    return e?.toLowerCase().includes(input?.toLowerCase());
  });
};
export default DixuSelect;